import React from "react";
import { Typography } from "@mui/material";
import SimplePaper from "../components/SimplePaper";

const ProjectInfo = () => {
  const title = "Project AstroData";

  const body = (
    <>
      <Typography variant="body1" paragraph>
        This project is centered on AI-based predictions, providing highly
        accurate and data-driven insights. The predictions are grounded in a
        rule-based system that also tracks how many times each rule is applied,
        its success rate, and failure rate. Each prediction comes with a
        probability percentage, offering clarity and precision in its outcomes.
      </Typography>

      <Typography variant="body1" paragraph>
        There is ongoing research that trains the AI over time. This continuous
        training refines the predictive models, enhancing their ability to learn
        from patterns in astrological data. The blend of AI, traditional
        astrological knowledge, and modern data science creates a unique
        framework that integrates both ancient wisdom and cutting-edge
        technology.
      </Typography>

      <Typography variant="body1" paragraph>
        Furthermore, the project delves into the inherent randomness of the
        universe, making use of complex algorithms to balance deterministic
        rules with probabilistic outcomes. It's a forward-thinking approach that
        merges the metaphysical aspects of astrology with empirical data,
        embracing the unpredictable nature of cosmic forces.
      </Typography>

      <Typography variant="body1" paragraph>
        You can also get consultations from astrologers in the exclusive{" "}
        <strong>AstroData-INSIDER-Club</strong>, known for their scientific
        approach. These consultations are available for a minimal custom charge
        and can be conducted via phone call, video call, or chat, offering
        personalized guidance and deeper insights based on your unique
        astrological chart.
      </Typography>

      <Typography variant="body1" paragraph>
        AI-based visual reports and weekly personalized insights are available,
        offering users real-time analysis and deeper interpretations to keep
        them well-informed.
      </Typography>

      <Typography variant="body1" paragraph>
        This is a personal research project aimed at revolutionizing
        astrological practices through the synergy of AI, traditional knowledge,
        and the evolving methodologies of data science. The goal is not just to
        predict, but to evolve, eradicate the influence of fake astrologers, and
        provide genuine, reliable insights.
      </Typography>

      <Typography variant="body1" paragraph>
        There is also an exclusive, invite-only{" "}
        <strong>AstroData-INSIDER-Club</strong> for those interested in deeper
        research insights and collaboration. If you’re interested in becoming a
        part of this club, feel free to contact us at{" "}
        <a href="mailto:support@astrodata.app">support@astrodata.app</a> to
        discuss eligibility for membership.
      </Typography>
    </>
  );

  return (
    <>
      <SimplePaper title={title} body={body} />
    </>
  );
};

export default ProjectInfo;
